import { Link } from "@/i18n/navigation";
import { CategoryModel } from "@/types/category";
import { useLocale } from "next-intl";
import Image from "next/image";
import React from "react";

const CategoryCard = ({ cat }: { cat: CategoryModel }) => {
  const locale = useLocale();
  return (
    <Link scroll href={`/categories/${cat.id}`} className="group relative">
      <div
        className="
              relative overflow-hidden
              h-[150px]
              rounded-2xl
              bg-gradient-to-br from-white to-gray-50
              border border-gray-100
              transition-all duration-300 ease-out
              hover:-translate-y-2 hover:shadow-[0_15px_40px_rgba(0,0,0,0.08)]
            "
      >
        {/* Glow */}
        <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-300 bg-gradient-to-r from-primary/20 via-transparent to-primary/20 blur-xl" />

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full gap-4 p-4">
          <div className="w-16 h-16 flex items-center justify-center rounded-xl transition duration-300 group-hover:scale-110">
            <Image src={cat.image_url} width={50} height={50} alt={cat.name} />
          </div>

          <h3 className="font-medium text-center transition duration-300 group-hover:text-primary">
            {cat.name}
          </h3>

          <span className="absolute bottom-2 text-sm opacity-0 translate-y-2 transition duration-300 group-hover:opacity-100 group-hover:translate-y-0">
            {locale === "ar" ? "←" : "→"}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
